import {
  AccountService,
  CallableAPI,
  CodeDeckService,
  OrganisationService,
  ProductTableService,
  RatingTableService,
  TicketService,
  User,
  UserService,
  VoiceRegionService,
  XeroService,
} from "callable-data-objects";
import NumberPoolService from "callable-data-objects/dist/services/NumberPoolService";
import PermissionService from "callable-data-objects/dist/services/PermissionService";
import RoleService from "callable-data-objects/dist/services/RoleService";
import Keycloak from "keycloak-js";
import { VIVA_BASE_URL } from "Props";
import React, { Fragment, useEffect, useState } from "react";
import { Dimmer, Loader } from "semantic-ui-react";

class API {
  keycloak: Keycloak.KeycloakInstance;
  organisationService: OrganisationService;
  xeroService: XeroService;
  accountService: AccountService;
  userService: UserService;
  ratingTableService: RatingTableService;
  codeDeckService: CodeDeckService;
  productTableService: ProductTableService;
  ticketService: TicketService;
  roleService: RoleService;
  permissionService: PermissionService;
  poolService: NumberPoolService;
  regionService: VoiceRegionService;
  me: User;

  constructor(values: any) {
    this.keycloak = values.keycloak;
    this.organisationService = values.organisation;
    this.xeroService = values.xeroService;
    this.accountService = values.account;
    this.userService = values.user;
    this.codeDeckService = values.codeDeck;
    this.ratingTableService = values.ratingTable;
    this.productTableService = values.productTable;
    this.ticketService = values.ticketService;
    this.roleService = values.roleService;
    this.permissionService = values.permissionService;
    this.poolService = values.poolService;
    this.regionService = values.regionService;
    this.me = values.me;
  }
}

type ProviderProps = {
  children: any;
  keycloak: Keycloak.KeycloakInstance;
};

const APIContext = React.createContext<API>(undefined!);

function useAPI(): API {
  return React.useContext(APIContext);
}

const APIProvider = ({ children, keycloak }: ProviderProps) => {
  const [api, setAPI] = useState<API>();

  useEffect(() => {
    if (!api) {
      if (!keycloak.token) throw new Error("No token");
      getMe(keycloak.token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getMe(token: string) {
    const {
      organisation,
      xero,
      account,
      user,
      codeDeck,
      ratingTable,
      productTable,
      ticket,
      role,
      permission,
      pool,
      region,
    } = new CallableAPI(VIVA_BASE_URL, token);

    const me = await user.me();

    setAPI({
      keycloak: keycloak,
      organisationService: organisation,
      xeroService: xero,
      accountService: account,
      userService: user,
      codeDeckService: codeDeck,
      ratingTableService: ratingTable,
      productTableService: productTable,
      ticketService: ticket,
      roleService: role,
      permissionService: permission,
      poolService: pool,
      regionService: region,
      me,
    });
  }

  if (api) {
    return <APIContext.Provider value={api}>{children}</APIContext.Provider>;
  }

  return (
    <Fragment>
      <Dimmer active={!api}>
        <Loader size='large' />
      </Dimmer>
    </Fragment>
  );
};

export { APIProvider, useAPI };
